import React from 'react';
import NumberFormat from 'react-number-format';
import classes from './PlanPortfolio.css';

// change me
const planPortfolio = (props) => {
    return (
        <div className="PlanPortfolio">
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.begginingPortfolioValue}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        decimalScale="0"
                    />
                </label>
            </div>
            <div className="portfolioValue tall">
            </div>
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.endingPortfolioValue}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        decimalScale="0"
                    />
                </label>
            </div>
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.averageReturns}
                        displayType={'text'}
                        thousandSeparator={true}
                        suffix={'%'}
                        decimalScale="2"
                    />
                </label>
            </div>
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.standardDeviation}
                        displayType={'text'}
                        thousandSeparator={true}
                        suffix={'%'}
                        decimalScale="2"
                    />
                </label>
            </div>
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.sharpeRatio}
                        displayType={'text'}
                        thousandSeparator={true}
                        suffix={'%'}
                        decimalScale="2"
                    />
                </label>
            </div>
            <div className="portfolioValue">
                <label>
                    <NumberFormat
                        value={props.portfolioInfo.sortinoRatio}
                        displayType={'text'}
                        thousandSeparator={true}
                        suffix={'%'}
                        decimalScale="2"
                    />
                </label>
            </div>
        </div>
    )
};

export default planPortfolio;



// WEBPACK FOOTER //
// ./src/components/PlanPortfolio/PlanPortfolio.js